<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.9718 25C22.5102 25 27 20.5228 27 15C27 9.47715 22.5102 5 16.9718 5C11.4334 5 6.94357 9.47715 6.94357 15" stroke="black" stroke-width="3"/>
<path d="M3 7.56389L6.94358 15L14.3638 11.048" stroke="black" stroke-width="3"/>
</svg>
